import React from 'react';
import { useChatWidgetContext } from '../../ChatWidgetContext';
import { useLlmDebugFlag } from '../../useLlmDebugFlag';
import { formatCost } from '../../llmPriceUtils';
import styles from '../ChatWidget.module.scss';

export default function ConversationCost() {
  const { totalConversationCost, isStreaming } = useChatWidgetContext();
  const isDebugEnabled = useLlmDebugFlag();

  if (!isDebugEnabled || totalConversationCost === 0 || isStreaming) {
    return null;
  }

  return (
    <div className={styles.conversationCost} data-testid="conversation-cost">
      Total conversation cost: {formatCost(totalConversationCost)}
    </div>
  );
}
